import React from "react";
import {
  TextField,
  Table,
  TableBody,
  TableContainer,
  TableHead,
} from "@material-ui/core";
import { StyledTableCell, StyledTableRow } from "../modules/modules";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  table: {
    width: "100%",
    height: "600px",
  },
}));

// 受注情報のヘッダー情報
const columns = [
  { id: "name", minWidth: 60, type: "text" },
  { id: "email", minWidth: 170, type: "text" },
  { id: "id", minWidth: 170, type: "text" },
  { id: "userId", minWidth: 170, type: "text" },
  { id: "link", minWidth: 170, type: "text" },
  { id: "amount", minWidth: 60, type: "number" },
];

// ■■■■■■■■■■■■■■■■■■
// list
// ■■■■■■■■■■■■■■■■■■
export default function UserOrder(props) {
  const classes = useStyles();
  const userOrders = props.userOrders;

  return (
    <React.StrictMode>
      <TableContainer className={classes.table}>
        <Table stickyHeader>
          <TableHead>
            <StyledTableRow>
              {columns.map((column) => (
                <StyledTableCell key={column.id}>{column.id}</StyledTableCell>
              ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {userOrders.map((row) => {
              return (
                <StyledTableRow key={row["id"]}>
                  {columns.map((column) => (
                    <>
                      <StyledTableCell
                        key={column.id}
                        style={{ minWidth: column.minWidth }}
                      >
                        <TextField
                          label={column["id"]}
                          name={row["id"]}
                          type={column["type"]}
                          defaultValue={row[column["id"]]}
                        />
                      </StyledTableCell>
                    </>
                  ))}
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </React.StrictMode>
  );
}
